import {
  CUSTOM_BUTTON_SIZE,
  CUSTOM_BUTTON_VARIANT,
  CustomButton,
  // @ts-expect-error - CustomButton is not typed yet
} from 'src/components/CustomButton';
import { CustomTypography, TYPOGRAPHY_VARIANT } from 'src/components/CustomTypography';
import { ROUTES } from 'src/routes';

import { useStyles } from '../useStyles';

interface Props {
  appDisplayName: string;
  approving: boolean;
  copilotAccountName: string | null;
  copilotWorkspaceName: string | null;
  onApprove: () => void;
  onDeny: () => void;
}

export const ConsentForm = ({
  appDisplayName,
  approving,
  copilotAccountName,
  copilotWorkspaceName,
  onApprove,
  onDeny,
}: Props) => {
  const styles = useStyles();

  return (
    <>
      <CustomTypography
        variant={TYPOGRAPHY_VARIANT.h1}
        className={styles.title}
      >
        Connect to Anyword
      </CustomTypography>
      <CustomTypography
        variant={TYPOGRAPHY_VARIANT.regular14}
        className={styles.body}
      >
        <strong>{appDisplayName}</strong> is requesting to connect to your Anyword account.
      </CustomTypography>

      <div className={styles.infoBlock}>
        {copilotAccountName && (
          <CustomTypography>
            <strong>Account:</strong> {copilotAccountName}
          </CustomTypography>
        )}
        {copilotWorkspaceName && (
          <CustomTypography>
            <strong>Workspace:</strong> {copilotWorkspaceName}
          </CustomTypography>
        )}
      </div>

      <CustomTypography className={styles.changeLink}>
        {'Change account or workspace settings '}
        <a
          href={ROUTES.SETTINGS}
          className={styles.link}
        >
          here
        </a>
      </CustomTypography>

      <div className={styles.actions}>
        <CustomButton
          fullWidth
          variant={CUSTOM_BUTTON_VARIANT.contained}
          size={CUSTOM_BUTTON_SIZE.medium}
          onClick={onApprove}
          disabled={approving}
          data-testid="OAuthConsentPage__Approve"
        >
          {approving ? 'Connecting…' : 'Allow'}
        </CustomButton>
        <CustomButton
          fullWidth
          variant={CUSTOM_BUTTON_VARIANT.outlined}
          size={CUSTOM_BUTTON_SIZE.medium}
          onClick={onDeny}
          className={styles.denyButton}
          data-testid="OAuthConsentPage__Deny"
        >
          Deny
        </CustomButton>
      </div>
    </>
  );
};
